import { useRole } from "modules/roles/hooks/useRole";

export function useIsValidator() {
  const role = useRole();
  return (
    role?.includes("LEGAL_VALIDATOR") || role?.includes("COMMERCIAL_VALIDATOR")
  );
}
